import React from 'react';
import styles from 'src/scenarios';
import { createDialog } from 'components/base/dialog';
import { DragSource, DropTarget } from 'react-dnd';
import QueryFieldDialog from './query_field_dialog';

class QueryListItem extends React.Component {
  onFieldCodeChange = (e) => {
    e.preventDefault();
    var key = e.target.value;
    var r = { ...this.props.data };
    this.props.field_options.forEach((opt) => {
      if (opt.code == key) {
        r.field_type = opt.type;
        r.field_code = opt.code;
        r.field_label = opt.label;
        r.additional_explanation = opt.additional_explanation;
        r.options = opt.options
          ? JSON.stringify(this.props.getOptionsByKintoneField(opt))
          : null;
        r.allow_to_skip = false;
        r.lookup_drill_down_app = null;
        r.lookup_drill_down_field = null;
        r.use_default = 'unused';
        this.props.onChange(this.props.index, 'queries', r);
      }
    });
  };

  onChange = (props) => {
    var r = { ...this.props.data, ...props };
    this.props.onChange(this.props.index, 'queries', r);
  };

  onSettingsClick = (e) => {
    e.preventDefault();
    createDialog(QueryFieldDialog, {
      data: this.props.data,
      onChange: this.onChange,
      lookupFieldMappings: this.props.lookupFieldMappings,
    });
  };

  onAdd = (e) => {
    e.preventDefault();
    this.props.onAdd(this.props.index, 'queries');
  };

  onRemove = (e) => {
    e.preventDefault();
    this.props.onRemove(this.props.index, 'queries');
  };

  render() {
    if (
      !this.props.connectDragPreview ||
      !this.props.connectDragSource ||
      !this.props.connectDropTarget
    )
      return;

    return this.props.connectDragPreview(
      this.props.connectDropTarget(
        <div className="row">
          <div className="col-sm-1">
            {this.props.connectDragSource(
              <button type="button" className="btn-sm handle text-center">
                <i className="material-icons">reorder</i>
              </button>,
              { dropEffect: 'move' },
            )}
          </div>
          <div className="col-sm-5">
            <select
              className="form-control"
              id={this.props.id}
              value={this.props.data.field_code || ''}
              onChange={this.onFieldCodeChange}
            >
              <option key="#blank" value="" />
              {this.props.field_options.map((o) => {
                return (
                  <option key={o.code} value={o.code}>
                    {o.label}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="col-sm-2">
            {this.props.data.field_code && (
              <span className="form-text">
                <a href="#!" onClick={this.onSettingsClick}>
                  検索項目の設定
                </a>
              </span>
            )}
          </div>
          <div className="col-sm-4 align-self-center">
            <span className={styles.buttons}>
              <a href="#!" onClick={this.onAdd}>
                <i className="material-icons mr-1">add_circle</i>
              </a>
              {this.props.removable && (
                <a href="#!" onClick={this.onRemove}>
                  <i className="material-icons mr-1">remove_circle</i>
                </a>
              )}
            </span>
          </div>
        </div>,
      ),
    );
  }
}

const itemSource = {
  beginDrag(props) {
    return props;
  },
};

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

const itemTarget = {
  hover(hoverProps, monitor, hoverComponent) {
    let dragProps = monitor.getItem();

    if (!hoverProps.data || !dragProps.data) return;
    if (hoverProps.data.id == dragProps.data.id) return;

    dragProps.onChangeOrder(dragProps.data, hoverProps.data, 'queries');
  },
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
}

var DecorateListItem = DragSource(
  'query_list_item',
  itemSource,
  collectSource,
)(QueryListItem);
DecorateListItem = DropTarget(
  'query_list_item',
  itemTarget,
  collectTarget,
)(DecorateListItem);

export default DecorateListItem;
